export enum REQUEST_TYPES {
  FullRequest = 1,
  ValueAddedRequest = 2,
  producteElementsrequest = 3,
  TopNRequest = 4,
  ContractRequest = 5,
}
